import { combineReducers } from 'redux';
import message from './message';
import ui from './ui';
import ark from './ark';
import setting from './setting'
import feedback from './feedback'
import realtimeAnswer from './realtimeAnswer'
import config from './config'
import ssoCheck from './ssoCheck'

const rootReducer = combineReducers({
    message, 
    ui, 
    ark,
    setting,
    feedback,
    realtimeAnswer,
    config
    ,ssoCheck
});

export default rootReducer;